<template>
    <div class="block-header">
            <div class="row">
                <div class="col-lg-7 col-md-6 col-sm-12">
                    <transition name="fade" mode="out-in">
                        <div :key="this.$route.name"><h2>{{titlePage}}</h2></div>
                    </transition>
                    
                    <transition-group name="breadcrumb" tag="ul" class="breadcrumb">
                        <li class="breadcrumb-item" v-for="(item,index) in breads" :key="index+item.name">
                            <span v-if="index == breads.length - 1">{{getTitle(item.name)}}</span>
                            <router-link v-else :to="item.path"><i class="mm-icon mm-icon-home" v-if="index==0"></i> {{getTitle(item.name)}}</router-link>
                        </li>
                    </transition-group>
                </div>
            </div>
        </div>
</template>

<script>

export default {
        name: 'Breadcrumb',
        data() {
            return {
                breads: [],
                titlePage: ''
            }
        },
        mounted: function() {
            this.getBreadcrumb();
        },
        watch: {
            $route() {
                this.getBreadcrumb()
            }
        },
        methods: {
            getBreadcrumb() {

                this.breads = this.$route.matched.filter(item => item.path && item.name).map(item => ({ name: item.name, path: item.path }));

                this.breads.unshift({path: '/home', name: 'home'});

                //si ultimo y penultimo elemento son iguales, estamos en una sub-pagina, y la quitamos del breadcrumb
                if(this.breads.length>2 && this.breads[this.breads.length-1].name==this.breads[this.breads.length-2].name) this.breads.pop();

                this.titlePage = this.$i18n.t(`menu.${this.$route.name}`);
            },
            getTitle(item) {
                return this.$i18n.t(`menu.${item}`);
            }
        }
}
</script>

<style>
.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all .5s;
}

.breadcrumb-enter,
.breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(20px);
}

.breadcrumb-move {
  transition: all .5s;
}

.breadcrumb-leave-active {
  position: absolute;
}
</style>